The identifier for the `AdvertisementBranding`.
